import styled, { css } from "styled-components"
import theme from "../../theme"

const ModalButton = styled<any, "button">("button")`
  background-color: ${theme.colors.success};
  border-color: transparent;
  color: #fff;
  margin-right: 10px;
  box-shadow: none;
  font-family: ${theme.fonts.primary};
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  &:disabled {
    opacity: 0.5;
    background-color: ${theme.colors.success};
    border-color: transparent;
    box-shadow: none;
    cursor: not-allowed;
  }
  &:hover {
    background-color: ${theme.colors.success};
    border-color: transparent;
    color: #fff;
  }
  ${(props: any) =>
    props.primary &&
    css`
      width: 100%;
      height: 50px;
    `};

  ${(props: any) =>
    props.secondary &&
    css`
      color: white;
      background: ${theme.colors.grey};
      width: 100%;
      height: 50px;
      &:hover {
        background-color: ${theme.colors.grey};
        opacity: 1;
        border-color: transparent;
      }
    `};
`

export default ModalButton
